export type IIconCategory = {
  title: string;
  icon: string;
  id: string;
};

export type IIcon = {
  name: string;
  category: string;
  description?: string;
};

export type CategoryWithIcon = {
  category?: IIconCategory;
  icons?: IIcon[];
};

export const allLucideCategories = [
  {
    title: 'Accounts & access',
    icon: 'circle_user_round',
    id: 'account',
  },
  {
    title: 'Arrows',
    icon: 'circle_chevron_down',
    id: 'arrows',
  },
  {
    title: 'Coding & development',
    icon: 'message_circle_code',
    id: 'development',
  },
  {
    title: 'Devices',
    icon: 'smartphone',
    id: 'devices',
  },
  {
    title: 'File icons',
    icon: 'file',
    id: 'files',
  },
  {
    title: 'Layout',
    icon: 'layers_3',
    id: 'layout',
  },
  {
    title: 'Shapes',
    icon: 'sparkles',
    id: 'shapes',
  },
  {
    title: 'Text formatting',
    icon: 'clipboard_type',
    id: 'text',
  },
  {
    id: 'other',
    icon: 'aperture',
    title: 'Other',
  },
];

export const iconCategories: IIconCategory[] = [
  { title: 'All', id: 'all', icon: 'aperture_svg_icons' },
  ...allLucideCategories.map((one) => ({
    title: one.title,
    icon: one.icon + '_svg_icons',
    id: one.id,
  })),
];
